exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slide-fade-enter-active[data-v-771d2836], .slide-fade-leave-active[data-v-771d2836] {\n    transition: transform 0.5s ease-in-out; /* Reduced time to 0.5s for faster animation */\n}\n.slide-fade-enter[data-v-771d2836] {\n    transform: translateY(-100%); /* Starts from top */\n}\n.slide-fade-leave-to[data-v-771d2836] {\n    transform: translateY(100%); /* Goes to bottom */\n}\n.fade-enter-active[data-v-771d2836],\n.fade-leave-active[data-v-771d2836] {\n    transition: opacity 0.5s ease;\n}\n.fade-enter-from[data-v-771d2836],\n.fade-leave-to[data-v-771d2836] {\n    opacity: 0;\n}\n", ""]);

// exports
